import craftsmanshipHero from "@/assets/craftsmanship-hero.jpg";
import { Award, Heart, Clock } from "lucide-react";

const Craftsmanship = () => {
  return (
    <section className="py-20 bg-gradient-to-b from-cream/30 to-background relative overflow-hidden">
      {/* Decorative background */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-5xl h-full opacity-5">
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxnIGZpbGw9IiM4YjZiNDciIGZpbGwtb3BhY2l0eT0iMC4wNSI+PHBhdGggZD0iTTM2IDE4YzMuMzE0IDAgNi0yLjY4NiA2LTZzLTIuNjg2LTYtNi02LTYgMi42ODYtNiA2IDIuNjg2IDYgNiA2em0xMiAxMmMzLjMxNCAwIDYtMi42ODYgNi02cy0yLjY4Ni02LTYtNi02IDIuNjg2LTYgNiAyLjY4NiA2IDYgNnoiLz48L2c+PC9nPjwvc3ZnPg==')] opacity-30"></div>
      </div>

      <div className="container mx-auto px-4 relative">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="animate-fade-in">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-primary/10 rounded-full mb-6">
              <Award className="w-4 h-4 text-primary" />
              <span className="text-primary font-semibold text-sm">Tradiție și calitate</span>
            </div>

            <h2 className="text-4xl md:text-6xl font-bold text-primary mb-6 leading-tight">
              Meșteșug Autentic
              <br />
              <span className="text-accent">din 2002</span>
            </h2>
            
            <p className="text-lg text-muted-foreground mb-6 leading-relaxed font-lora">
              Fiecare carte este o operă de artă, creată manual cu unelte tradiționale 
              și tehnică artizanală transmisă din generație în generație.
            </p>
            
            <p className="text-lg text-muted-foreground mb-8 leading-relaxed font-lora">
              De peste 20 de ani, dedicăm pasiune și măiestrie fiecărui proiect, 
              combinând tradiția cu perfecțiunea detaliilor.
            </p>

            <div className="space-y-4">
              <div className="flex items-start gap-4 p-4 bg-card/50 rounded-lg border border-border/50 hover-scale hover-glow transition-all">
                <div className="flex-shrink-0 w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center">
                  <Heart className="w-6 h-6 text-primary" />
                </div>
                <div>
                  <h3 className="font-semibold text-foreground mb-1">Legătorie manuală în piele naturală</h3>
                  <p className="text-sm text-muted-foreground font-lora">Materiale premium selectate cu grijă</p>
                </div>
              </div>

              <div className="flex items-start gap-4 p-4 bg-card/50 rounded-lg border border-border/50 hover-scale hover-glow transition-all">
                <div className="flex-shrink-0 w-12 h-12 bg-accent/10 rounded-full flex items-center justify-center">
                  <Award className="w-6 h-6 text-accent" />
                </div>
                <div>
                  <h3 className="font-semibold text-foreground mb-1">Personalizare completă</h3>
                  <p className="text-sm text-muted-foreground font-lora">Adaptată după dorințele clientului</p>
                </div>
              </div>

              <div className="flex items-start gap-4 p-4 bg-card/50 rounded-lg border border-border/50 hover-scale hover-glow transition-all">
                <div className="flex-shrink-0 w-12 h-12 bg-gold/10 rounded-full flex items-center justify-center">
                  <Clock className="w-6 h-6 text-gold" />
                </div>
                <div>
                  <h3 className="font-semibold text-foreground mb-1">Tehnici tradiționale</h3>
                  <p className="text-sm text-muted-foreground font-lora">Meșteșug autentic păstrat în timp</p>
                </div>
              </div>
            </div>
          </div>

          <div className="relative animate-fade-in" style={{ animationDelay: '0.3s' }}>
            <div className="relative h-[500px] rounded-2xl overflow-hidden shadow-2xl hover-scale transition-transform duration-700">
              <img 
                src={craftsmanshipHero} 
                alt="Meșteșug tradițional de legătorie în piele - unelte artizanale Idaco" 
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-burgundy-dark/60 via-transparent to-transparent"></div>
              
              {/* Decorative frame */}
              <div className="absolute inset-4 border-2 border-gold/30 rounded-xl pointer-events-none"></div>
            </div>
            
            {/* Floating decorative elements */}
            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-gradient-to-br from-gold/20 to-accent/20 rounded-full blur-3xl animate-float"></div>
            <div className="absolute -top-6 -left-6 w-32 h-32 bg-gradient-to-br from-primary/20 to-burgundy/20 rounded-full blur-3xl animate-float" style={{ animationDelay: '1s' }}></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Craftsmanship;
